import { getInitials, avatarColorClass } from "../../lib/avatar";
import { STAGE_LABEL, prospectSourceLabel } from "../../lib/pipeline";
import { PilotTag } from "../PilotBits";
import { CustomerMark } from "../customers/CustomerBits";
import {
  ResponsiveDropdownMenu as DropdownMenu, ResponsiveDropdownMenuTrigger as DropdownMenuTrigger, ResponsiveDropdownMenuContent as DropdownMenuContent,
} from "../ui/responsive-dropdown-menu";
import { MoreHorizontal, MapPin } from "lucide-react";

// Mobile prospect card: the whole card opens ProspectDetail, like the desktop
// row's onClick; the "⋯" trigger stops propagation so it never also opens the
// detail. Only fields present on the prospect are shown. The technical id
// (#abcdef12) is omitted: a commercial doesn't need it day to day, and it
// stays on the detail page.
export function ProspectCard({ p, navigate, userName, hasAnyRowAction, actionItems, customerBadge = null }) {
  const commercialName = userName(p.assigned_to);
  const location = [p.commune, p.region].filter(Boolean).join(", ");
  return (
    <div
      data-testid={`prospect-card-${p.id}`}
      className="rounded-lg border border-slate-100 bg-white px-3 py-2 active:bg-slate-50 transition"
      onClick={() => navigate(`/prospects/${p.id}`)}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="font-medium text-sm text-slate-900 break-words">{p.pharmacy_name}</div>
        {hasAnyRowAction && (
          <div onClick={(e) => e.stopPropagation()} className="shrink-0">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button
                  type="button"
                  className="h-7 w-7 flex items-center justify-center rounded hover:bg-slate-100 text-slate-500"
                  data-testid={`btn-prospect-actions-mobile-${p.id}`}
                >
                  <MoreHorizontal size={16} />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">{actionItems}</DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>

      <div className="mt-1 flex flex-wrap items-center gap-1.5">
        <span className={`text-2xs font-semibold uppercase tracking-wider px-2 py-1 rounded stage-${p.status}`}>
          {STAGE_LABEL[p.status]}
        </span>
        <PilotTag status={p.pilot_status} testid={`pilot-tag-mobile-${p.id}`} />
        <CustomerMark badge={customerBadge} />
      </div>

      {location && (
        <div className="mt-1 flex items-center gap-1 text-xs text-slate-600">
          <MapPin size={12} className="text-slate-400 shrink-0" /> {location}
        </div>
      )}

      <div className="mt-1 flex items-center justify-between gap-2 text-xs">
        {p.assigned_to ? (
          <span className="inline-flex items-center gap-1.5 min-w-0 text-slate-700">
            <span className={`w-5 h-5 rounded-full flex items-center justify-center text-2xs font-semibold shrink-0 ${avatarColorClass(p.assigned_to)}`}>
              {getInitials(commercialName)}
            </span>
            <span className="truncate">{commercialName || "Utilisateur"}</span>
          </span>
        ) : <span className="text-slate-400">Non assigné</span>}
        {p.source && <span className="text-slate-400 shrink-0">{prospectSourceLabel(p.source)}</span>}
      </div>
    </div>
  );
}
